import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "20",
  cy: "20",
  r: "16.667",
  fill: "#FF9A12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M20 24.838a1.908 1.908 0 1 0 0 3.817 1.908 1.908 0 0 0 0-3.817Zm0-2.676c-.79 0-1.431-.642-1.431-1.432v-7.955a1.433 1.433 0 0 1 2.863 0v7.955c0 .79-.642 1.432-1.432 1.432Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "circle-warning-orange"}) } }